var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEwaAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 10,
    fill: "#EEF4FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3494_36080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 23.667L43 21.667L41 23.667L39 21.667L37 23.667L35 21.667L33 23.667L31 21.667L29 23.667L27 21.667V40.3337H23V44.3337C23 46.547 24.7867 48.3337 27 48.3337H43C45.2133 48.3337 47 46.547 47 44.3337V21.667L45 23.667ZM39 45.667H27C26.2667 45.667 25.6667 45.067 25.6667 44.3337V43.0003H39V45.667ZM44.3333 44.3337C44.3333 45.067 43.7333 45.667 43 45.667C42.2667 45.667 41.6667 45.067 41.6667 44.3337V40.3337H29.6667V25.667H44.3333V44.3337Z",
    fill: "#004AF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 28.334H31V31.0007H39V28.334Z",
    fill: "#004AF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9997 28.334H40.333V31.0007H42.9997V28.334Z",
    fill: "#004AF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 32.334H31V35.0007H39V32.334Z",
    fill: "#004AF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9997 32.334H40.333V35.0007H42.9997V32.334Z",
    fill: "#004AF5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3494_36080"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(19 19)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEwaAccount);
export default __webpack_public_path__ + "static/media/ewa-account.a2b26fad43592c3cda151f503f1bd3c2.svg";
export { ForwardRef as ReactComponent };